"use strict";
exports.__esModule = true;
exports.evaluateOpCode_function = void 0;
function evaluateOpCode_function(context, _a) {
    var name = _a.name, value = _a.value;
    var result = [];
    var stringArgCallback = name in stringArgCallbacks ? stringArgCallbacks[name] : undefined;
    var noArgCallback = !stringArgCallback && name in noArgCallbacks
        ? noArgCallbacks[name]
        : undefined;
    if (stringArgCallback) {
        if (value === undefined) {
            throw new Error('Unexpected value for string arg callback');
        }
        for (var _i = 0, context_1 = context; _i < context_1.length; _i++) {
            var each = context_1[_i];
            result.push(stringArgCallback(each, value));
        }
    }
    else if (noArgCallback) {
        if (value !== undefined) {
            throw new Error('Unexpected value for no arg callback');
        }
        for (var _b = 0, context_2 = context; _b < context_2.length; _b++) {
            var each = context_2[_b];
            result.push(noArgCallback(each));
        }
    }
    else {
        throw new Error('Unknown function name: ' + name);
    }
    return result;
}
exports.evaluateOpCode_function = evaluateOpCode_function;
var noArgCallbacks = {
    ltrim: function (each) {
        if (typeof each !== 'string')
            throw new Error("Cannot ltrim ".concat(typeof each));
        return each.trimStart();
    },
    rtrim: function (each) {
        if (typeof each !== 'string')
            throw new Error("Cannot rtrim ".concat(typeof each));
        return each.trimEnd();
    },
    trim: function (each) {
        if (typeof each !== 'string')
            throw new Error("Cannot trim ".concat(typeof each));
        return each.trim();
    }
};
var stringArgCallbacks = {
    startswith: function (each, value) {
        if (typeof each !== 'string')
            throw new Error("Cannot startswith ".concat(typeof each));
        return each.startsWith(value);
    },
    endswith: function (each, value) {
        if (typeof each !== 'string')
            throw new Error("Cannot endswith ".concat(typeof each));
        return each.endsWith(value);
    },
    ltrimstr: function (each, value) {
        return stringArgCallbacks.startswith(each, value) ? each.slice(value.length) : value;
    },
    rtrimstr: function (each, value) {
        return stringArgCallbacks.endswith(each, value) ? each.slice(0, 0 - value.length) : value;
    },
    split: function (each, value) {
        if (typeof each !== 'string')
            throw new Error("Cannot split ".concat(typeof each));
        return each.split(value);
    },
    join: function (each, value) {
        if (!Array.isArray(each))
            throw new Error("Cannot join ".concat(typeof each));
        return each.join(value);
    }
};
